import React from "react";
import styles from "./drcarloscrepaldi.module.scss";

import logoImg from "./src/logo.png";
import curriculoImg from "./src/curriculo.png";
import siteImg from "./src/site.png";
import instagramImg from "./src/instagram.png";
import mapsImg from "./src/maps.png";
import servicosImg from "./src/servicos.png";
import whatsappImg from "./src/whatsapp.png";
import { Link } from "react-router-dom";

const Drcarloscrepaldi: React.FC = () => {
    const items = [
        { img: curriculoImg, text: "CV LATTES", borderLeft: true, borderRight: false, link: "http://lattes.cnpq.br/1147277429250898", router: false },
        { img: siteImg, text: "SITE", borderLeft: true, borderRight: true, link: "http://www.2cadvocacia.com.br/", router: false },
        { img: instagramImg, text: "INSTAGRAM", borderLeft: false, borderRight: true, link: "https://www.instagram.com/dr.carloscrepaldi?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==", router: false },
        { img: mapsImg, text: "LOCALIZAÇÃO", borderLeft: true, borderRight: false, link: "https://maps.app.goo.gl/Qwc67DU9oovXN2Nb6", router: false },
        { img: servicosImg, text: "SERVIÇOS", borderLeft: true, borderRight: true, link: "/drcarloscrepaldi/servicos", router: true },
        { img: whatsappImg, text: "WHATSAPP", borderLeft: false, borderRight: true, link: "https://wa.me/5517981168113?text=Olá! Vim pelo seu cartão digital e gostaria de mais informações...", router: true },
    ];

    return (
        <div className={styles.drcarloscrepaldi}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <img src={logoImg} alt="Logo Dona Vitta" className={styles.logo} />
                </div>
                <div className={styles.body}>
                    <div className={styles.grid}>
                        {items.map((item, index) => (
                            item.router ?
                                (item.borderLeft && item.borderRight) ?
                                    <Link to={item.link}>
                                        <div key={index} className={styles.card} style={{ borderLeft: "1px solid #fff", borderRight: "1px solid #fff" }}>
                                            <img src={item.img} alt={item.text} />
                                            <p>{item.text}</p>
                                        </div>
                                    </Link>
                                    :
                                    item.borderLeft ?
                                        <Link to={item.link}>
                                            <div key={index} className={styles.card} style={{ borderLeft: "1px solid #fff" }}>
                                                <img src={item.img} alt={item.text} />
                                                <p>{item.text}</p>
                                            </div>
                                        </Link>
                                        :
                                        item.borderRight ?
                                            <Link to={item.link}>
                                                <div key={index} className={styles.card} style={{ borderRight: "1px solid #fff" }}>
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </Link>
                                            :
                                            <Link to={item.link}>
                                                <div key={index} className={styles.card} >
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </Link>
                                :
                                (item.borderLeft && item.borderRight) ?
                                    <a href={item.link} target="_blank">
                                        <div key={index} className={styles.card} style={{ borderLeft: "1px solid #fff", borderRight: "1px solid #fff" }}>
                                            <img src={item.img} alt={item.text} />
                                            <p>{item.text}</p>
                                        </div>
                                    </a>
                                    :
                                    item.borderLeft ?
                                        <a href={item.link} target="_blank">
                                            <div key={index} className={styles.card} style={{ borderLeft: "1px solid #fff" }}>
                                                <img src={item.img} alt={item.text} />
                                                <p>{item.text}</p>
                                            </div>
                                        </a>
                                        :
                                        item.borderRight ?
                                            <a href={item.link} target="_blank">
                                                <div key={index} className={styles.card} style={{ borderRight: "1px solid #fff" }}>
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </a>
                                            :
                                            <a href={item.link} target="_blank">
                                                <div key={index} className={styles.card} >
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </a>

                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Drcarloscrepaldi;
